export default String.raw`
{% assign showDeliveryAddressForm = false -%}
{% assign showDeliveryAddressChoose = false -%}
{% assign showInvoiceAddressForm = false -%}
{% assign showDeliveryMethodsForm = false -%}
{% assign showPaymentMethods = false -%}
{% assign showNotesForm = false -%}

{% assign disableOrderButton = false -%}
{% assign nextStep = '' -%}

{% if include == 'deliveryAddress' -%}
    {% assign showDeliveryAddressForm = true -%}
{% elseif include == 'deliveryAddressChoose' -%}
    {% assign showDeliveryAddressChoose = true -%}
{% elseif include == 'invoiceAddress' -%}
    {% assign showInvoiceAddressForm = true -%}
{% elseif include == 'deliveryMethods' -%}
    {% assign showDeliveryMethodsForm = true -%}
{% elseif include == 'paymentMethods' -%}
    {% assign showPaymentMethods = true -%}
{% else -%}
    {% assign showNotesForm = true -%}
{% endif -%}

{% if cart.SelectedDelivery.CollectionPointTypeId != 0 and cart.SelectedDelivery.CollectionPointTypeId != 10 and cart.SelectedDelivery.CollectionPointId == null  %}
	{% unless showPaymentMethods == true %}
		{% assign showDeliveryMethodsForm = true -%}
	{% endunless %}
{% endif %}

{% for deliveryMethod in cart.DeliveryMethods -%}
	{% if deliveryMethod.Name == cart.SelectedDelivery.Name -%}
		{% assign payment = deliveryMethod.Payments[0] -%}
			{% if payment.Id == cart.SelectedDeliveryPaymentId -%}
				{% if payment.Channels != null  -%}
					{% unless cart.SelectedDelivery.Payment.Channel %}
						{% assign showPaymentMethods = true -%}
					{% endunless %}
				{% endif -%}	
			{% endif -%}
	{% endif -%}
{% endfor -%}

{% for deliveryMethod in cart.DeliveryMethods -%}
	{% if deliveryMethod.Name == cart.SelectedDelivery.Name -%}
		{% for payment in deliveryMethod.Payments -%}
			{% if payment.Id == cart.SelectedDeliveryPaymentId -%}
				{% if payment.Channels != null  -%}
					{% if cart.SelectedDelivery.Payment.Channel == null %}
						{% assign isSelectedPaymentChannel = false -%}
					{%  else -%}
						{% assign isSelectedPaymentChannel = true -%}
					{% endif %}
					<input class="isSelectedPaymentChannel"  type="hidden" data-is-selected-payment-channel="{{ isSelectedPaymentChannel }}" />
				{% endif -%}	
			{% endif -%}
		{% endfor -%}
	{% endif -%}
{% endfor -%}

{% assign deliveryAddress = cart.Customer.DeliveryAddress -%}
{% assign invoiceAddress = cart.Customer.InvoiceAddress -%}
{% assign buyerAddress = cart.Customer.Buyer -%}

{% assign lackOfPhone = false -%}

{% assign noAddress = false -%}

{% if deliveryAddress.Name == '' or lackOfPhone -%}
	{% assign showDeliveryAddressForm = true -%}
	{% assign showNotesForm = false -%}
	{% assign noAddress = true -%}
{% elsif usr.Authenticated == false and cart.Customer.Company == false and cart.Customer.Invoice == false -%}
	{% assign noAddress = false -%}
{% elsif usr.Authenticated == false and invoiceAddress.Name == '' and settings.defaultRegistration == 'company' -%}
	{% assign showInvoiceAddressForm = true -%}
	{% assign showNotesForm = false -%}
	{% assign noAddress = true -%}
{% endif -%}

{% assign index = 0 -%}
{% assign areCountries = false -%}
{% assign addressesAmount = customer.DeliveryAddresses | Size -%}

{% if addressesAmount > 1 %}
    {% assign countryCode = config.DefaultCountry -%}
    {% if cart.Customer.DeliveryAddress.Country != '' -%}
        {% assign countryCode = cart.Customer.DeliveryAddress.Country -%}
    {% endif -%}
    {% for address in customer.DeliveryAddresses -%}
        {% if address.Country == countryCode -%}
            {% assign areCountries = true -%}
            {% break -%}
        {% endif -%}
    {% endfor -%}
{% endif -%}

{% if settings.blockAddingAndEditingDeliveryAddress == 'no' -%}
    {% assign canEditOrAddDeliveryAddress = true -%}
{% elseif settings.blockAddingAndEditingDeliveryAddressFor == 'withLimits' and customer.CreditLimit == null -%}
    {% assign canEditOrAddDeliveryAddress = true -%}
{% else -%}
    {% assign canEditOrAddDeliveryAddress = false -%}
{% endif -%}

<div class="cart-data-section">
    <div class="cart-data-section__header">
        <div class="cart-data-section__header-title">
            <div>
                {% if cart.SelectedDelivery.CollectionPointTypeId == 0 -%}
					{{ translations.DeliveryData }}
				{% else -%}
					{{translations.MyData}}
				{% endif -%}
            </div>
            {% if cart.Customer.Company -%}
                {% if cart.Customer.CustomerDetailsEditable == false or canEditOrAddDeliveryAddress == false -%}
                    <div class="cart-data-section__header-icon cart__tooltip cart-tooltip-js">
                        <svg class="cart__tooltip-icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
                        </svg>
                        <div class="cart__tooltip-info cart-tooltip-info-js hidden-js">
                            {{ translations.EditDataCartInfo }}
                        </div>
                    </div>
                {% endif -%}
            {% endif -%}
        </div>
        <div>
            {% if areCountries and cart.SelectedDelivery.CollectionPointTypeId == 0 and usr.Authenticated -%}
                {% if showDeliveryAddressChoose or showDeliveryAddressForm  -%}
					{% if settings.blockAddingAndEditingDeliveryAddress == 'no' -%}
						{% assign canEditOrAddDeliveryAddress = true -%}
					{% elseif settings.blockAddingAndEditingDeliveryAddressFor == 'withLimits' and customer.CreditLimit == null -%}
						{% assign canEditOrAddDeliveryAddress = true -%}
					{% else -%}
						{% assign canEditOrAddDeliveryAddress = false -%}
					{% endif -%}
					{% if canEditOrAddDeliveryAddress -%}
						<button class="cart__action-btn cart-data-section__header-btn cart-edit-customer-address-js">
							{{ translations.AddNewAddress }}
						</button>
					{% endif -%}
				{% else -%}
                    <button class="cart__action-btn cart-data-section__header-btn cart-edit-view-js" data-view="deliveryAddressChoose">
                        {{ translations.Change }}
                    </button>
                {% endif -%}
            {% else -%}
                {% unless cart.Customer.CustomerDetailsEditable == false or showDeliveryAddressForm -%}
                    {% assign addressEditionBlocker = false -%}
                    {% if cart.Customer.Company and canEditOrAddDeliveryAddress == false -%}
                        {% assign addressEditionBlocker = true -%}
                    {% endif -%}
                    {% unless addressEditionBlocker -%}
                        <button class="cart__action-btn cart-data-section__header-btn cart-edit-view-js" data-view="deliveryAddress">
                            {{ translations.Edit }}
                        </button>
                    {% endunless -%}              
                {% endunless -%}
            {% endif -%}
        </div>
    </div>
    <div class="cart-data-section__content address-template-container-js delivery-address-container-js">
        {% if showDeliveryAddressChoose -%}
			{% assign disableOrderButton = true -%}
            {% include 'partials/cart/delivery-partials/addresses-list.html' -%}
        {% else -%}
            {% if showDeliveryAddressForm -%}
                {% if cart.Customer.Company and canEditOrAddDeliveryAddress == false -%}
                    {% assign showDeliveryAddressForm = false -%}
                    {% include 'partials/cart/delivery-partials/address-presentation.html' with 'orderDa' -%}
                {% else -%}
					{% assign disableOrderButton = true -%}
                    {% include 'partials/cart/delivery-partials/address-form.html' with 'orderDa' -%}
                {% endif -%}
            {% else -%}
                {% include 'partials/cart/delivery-partials/address-presentation.html' with 'orderDa' -%}
            {% endif -%}
        {% endif -%}
    </div>
</div>

{% if settings.blockCompanyDataEdition == 'no' -%}
    {% assign canEditCustomerDetails = true -%}
{% elseif settings.blockCompanyDataEditionFor == 'withLimits' and customer.CreditLimit == null -%}
    {% assign canEditCustomerDetails = true -%}
{% else -%}
    {% assign canEditCustomerDetails = false -%}
{% endif -%}

<div class="cart-data-section">
    <div class="cart-data-section__header">
        <div class="cart-data-section__header-title">
            <div>
                {{ translations.InvoiceOrRecipeData }}
            </div>
            {% if cart.Customer.Company -%}
                {% if cart.Customer.CustomerDetailsEditable == false or canEditCustomerDetails == false -%}
                    <div class="cart-data-section__header-icon cart__tooltip cart-tooltip-js">
                        <svg class="cart__tooltip-icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
                        </svg>
                        <div class="cart__tooltip-info cart-tooltip-info-js hidden-js">
                            {{ translations.EditDataCartInfo }}
                        </div>
                    </div>
                {% endif -%}
            {% endif -%}
        </div>
        <div>
			{% assign showEditInvoiceForm = true -%}
			{% if usr.Authenticated == false and showDeliveryAddressForm -%}
				{% assign showEditInvoiceForm = false -%}
			{% endif -%}
			{% if cart.Customer.CustomerDetailsEditable and showInvoiceAddressForm == false and showEditInvoiceForm -%}
				{% assign addressEditionBlocker = false -%}
				{% if canEditCustomerDetails == false -%}
					{% assign addressEditionBlocker = true -%}
				{% endif -%} 
				{% unless addressEditionBlocker or noAddress == true -%}
					<button class="cart__action-btn cart-data-section__header-btn cart-edit-view-js" data-view="invoiceAddress">
						{{ translations.Edit }}
					</button>
				{% endunless -%}   
			{% endif -%} 
        </div>
    </div>
    <div class="cart-data-section__content {% if settings.buyerData == 'yes' -%} form-js {% endif -%}" {% if settings.buyerData == 'yes' -%} novalidate {% endif -%}>
        {% if showInvoiceAddressForm and cart.Customer.CustomerDetailsEditable and showDeliveryAddressForm == false and showDeliveryAddressChoose == false -%}
            {% assign disableOrderButton = true -%}
			<div class="with-database-check-js address-template-container-js invoice-address-container-js" 
				 data-edit-data-from-gus="{{settings.editDataFromGUS}}" 
				 data-edit-data-from-vies="{{settings.editDataFromVIES}}"
			>
                {% include 'partials/cart/delivery-partials/address-form.html' with 'inv-add' -%}
            </div>
            {% if settings.buyerData == "yes" %}
                <label class="cart__check-label cart-address-form__check">
                    <input name="buyer-data" class="buyer-data-change-form-js" type="checkbox" {% if cart.Customer.Buyer -%} checked {% endif -%} >
                    <div class="cart__check-checkbox">
                        <svg>
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                        </svg>
                    </div>
                    <div class="cart__check-text">
                        {{ translations.OtherBuyerData }}
                    </div>
                </label>
				<div class="address-template-container-js buyer-address-container-js with-database-check-js">
					{% include 'partials/cart/delivery-partials/address-form.html' with 'buyerAddress' -%}
				</div>
            {% endif -%}
        {% else -%}
            {% include 'partials/cart/delivery-partials/address-presentation.html' with 'inv-add'-%}
			{% if settings.buyerData == "yes" and cart.Customer.Buyer -%}
				<div class="cart-address-presentation__title">
					<svg class="cart-address-presentation__title-icon">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
					</svg>
					{{ translations.OtherBuyerData }}
				</div>
				{% include 'partials/cart/delivery-partials/address-presentation.html' with 'buyerAddress' -%}
			{% endif -%}
        {% endif -%}
    </div>
</div>

{% assign deliveryMethodsSize = cart.DeliveryMethods | Size -%}

<div class="cart-data-section">
    <div class="cart-data-section__header">
        <div class="cart-data-section__header-title">
            <div>
				{{ translations.MethodOfDelivery }}
            </div>
        </div>
        <div>
			{% if noAddress == false and showDeliveryMethodsForm == false and deliveryMethodsSize != 0 -%}
				<button class="cart__action-btn cart-data-section__header-btn cart-edit-view-js" data-view="deliveryMethods">
                    {{ translations.Edit }}
                </button>
			{% endif -%}
        </div>
    </div>
    
	<div class="cart-data-section__content collection-point-container-in-cart-js {% if cart.SelectedDelivery.CollectionPoint -%} collection-point-selected-js {% endif -%}">
		{% if deliveryMethodsSize == 0 -%}
			{% assign disableOrderButton = true -%}
			<div>{{ translations.NoDelivery }}</div>
		{% else -%}
				{% if showDeliveryMethodsForm and showDeliveryAddressForm == false and showInvoiceAddressForm == false -%}
					{% assign disableOrderButton = true -%}
					{% for deliveryMethod in cart.DeliveryMethods -%}
						{% assign selectedDelivery = false -%}
						{% assign deligooSelected = false -%}
						{% if deliveryMethod.Name == cart.SelectedDelivery.Name -%}
							{% assign indexTemp = forloop.index0 -%}
							{% for payment in deliveryMethod.Payments -%}
								{% if payment.Id == cart.SelectedDeliveryPaymentId -%}
									{% assign index = indexTemp -%}
									{% assign selectedDelivery = true -%}
									{% if cart.SelectedDelivery.FastDelivery -%}
										{% assign deligooSelected = true -%}
									{% endif -%}
								{% endif -%}
							{% endfor -%}
						{% endif -%}
						<label class="cart-delivery-item">
							<div class="cart-delivery-item__radio">
								<input class="cart__radio change-delivery-js" 
									type="radio" 
									name="delivery-method" 
									value="{{ deliveryMethod.Payments[0].Id }}" 
									{% if selectedDelivery -%} 
										checked 
										data-phone-required="{{ cart.SelectedDelivery.PhoneRequired }}"
									{% endif -%} 
									data-name="{{deliveryMethod.Name | H}}"
									data-free-from="{{deliveryMethod.FreeDeliveryFrom | ToNum}}"
									data-deligoo="{{deliveryMethod.FastDelivery}}"
									{% if deliveryMethod.FastDelivery -%} data-da-zip="{{cart.Customer.DeliveryAddress.ZipCode}}" {% endif -%}
									data-template="partials/cart/delivery-partials/delivery-section.html" 
									data-container=".delivery-section-container-js"
									data-include="deliveryMethods"
								>
								<div tabindex="0" role="radio" {% if selectedDelivery -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} class="cart__radio-box"></div>
							</div>
							<div class="cart-delivery-item__wrapper">
								<div class="cart-delivery-item__name">
									{% if deliveryMethod.ImageUrl != null -%}
										<img src="css/img/alo.gif" data-src="{{deliveryMethod.ImageUrl}}" alt="{{deliveryMethod.Name}}" title="{{deliveryMethod.Name}}" >
									{% endif -%}
									{{ deliveryMethod.Name }}
								</div>
								{% if selectedDelivery -%}
									{% if cart.SelectedDelivery.CollectionPointTypeId != 0 and cart.SelectedDelivery.CollectionPointTypeId != 10 -%}
										<div class="cart-delivery-item__collection-points collection-points-container-js">
											{% include 'partials/cart/delivery-partials/collection-points.html' -%}
										</div>
									{% endif -%}
								{% endif -%}
									
								{% if deliveryMethod.NotDeterminedDeliveryCost == false -%}
									<div class="cart-delivery-item__price">
										{{ deliveryMethod.TotalValue | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
									</div>
								{% else -%}
									<div class="cart-delivery-item__price-text">
										{{ translations.IndividualPrice }}
										<div class="cart__tooltip cart-tooltip-js">
											<svg class="cart__tooltip-icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
											</svg>
											<div class="cart__tooltip-info cart-tooltip-info-js hidden-js">
												{{ translations.NotDeterminedDeliveryCostInfo }}
											</div>
										</div>
									</div>
								{% endif -%}
								
								{% if deliveryMethod.FreeDeliveryFrom > cart.ProductsValue and deliveryMethod.TotalValue > 0 -%}
									<div class="cart-delivery-item__price-free">
										{{ translations.FreeDeliveryFrom }}: {{ deliveryMethod.FreeDeliveryFrom | Round: config.DecimalPlacesPrice | ToPrice }} {{ cart.CurrencyExt }} {% if customer.SubtotalPrices -%} {{ translations.Netto | Downcase }} {% endif -%}
									</div>
								{% endif -%}

								{% if selectedDelivery -%}
									{% if settings.scheduledDeliveryDateEditable == 'yes' and cart.SelectedDelivery.Time >= 0 -%}
										{% assign days = cart.SelectedDelivery.Time|ToString|ToTimeSpan -%}
										{% if settings.deliveryDateType == 'date' %}
											{% assign minDate = config.Now | Plus: days | Date:'yyyy-MM-dd' -%}
											{% assign maxDate = '2200-12-31' -%}
											{% if cart.SelectedDelivery.SelectedDate %}
												{% assign dateValue = cart.SelectedDelivery.SelectedDate | Date:'yyyy-MM-dd' -%}
											{% else -%}
												{% assign dateValue = minDate -%}
											{% endif -%}
											{% assign type = 'date' -%}
										{% else -%}
											{% assign minDate = config.Now | Plus: days | Date:'yyyy-MM-ddTHH:mm' -%}
											{% assign maxDate = '2200-12-31T23:59' -%}
											{% if cart.SelectedDelivery.SelectedDate %}
												{% assign dateValue = cart.SelectedDelivery.SelectedDate | Date:'yyyy-MM-ddTHH:mm' -%}
											{% else -%}
												{% assign dateValue = minDate -%}
											{% endif -%}
											{% assign type = 'datetime-local' -%}
										{% endif -%}
										<div class="form-js delivery-date-change-form-js form__input-wrapper cart-delivery-item__date">
											<input type="hidden" name="__action" value="Order/DeliveryDateChange" >
											<label class="form__input-info input-info-js" for="date">{{ translations.ScheduledDeliveryDate }}</label>
											<input class="form__input-value input-value-js" id="date" type="{{type}}" name="date" min="{{minDate}}" max="{{maxDate}}" data-value="{{dateValue}}" value="{{dateValue}}" >
										</div>
									{% elseif cart.SelectedDelivery.DateText != "" -%}
										<div class="cart-delivery-item__date info">
											{{ translations.ExpectedDeliveryTime }}
											<br >
											{{ cart.SelectedDelivery.DateText }}
										</div>
									{% endif -%}
								{% endif -%}
							</div>
						</label>
					{% endfor -%}

					{% if settings.deligoo == 'yes' -%}
						{% assign hideDeligooPopup = true -%}
						{% if deligooSelected and cart.Customer.DeliveryAddress.ZipCode == '' -%}
							{% assign hideDeligooPopup = false -%}
						{% endif -%}
						<div class="cart__popup {% if deligooSelected -%} deligoo-on-cart-js {% endif -%} check-deligoo-availability-popup-js container-to-hide-js {% if hideDeligooPopup -%} hidden-js {% endif -%}">
							<div class="cart__popup-box">
								<div class="cart__popup-header">
									<div class="cart__popup-title">
										<span>{{ translations.DeligooTitle }}</span>
									</div>
									<svg class="cart__popup-closer cart-popup-closer-js close-deligoo-popup-js hide-container-js {% if deligooSelected and cart.Customer.DeliveryAddress.ZipCode == '' -%} deligoo-fail-js {% endif -%}">
										<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
									</svg>
								</div>
								<div class="cart__popup-content">
									<div class="info">
										<div>{{ translations.DeligooTextInCart }}</div>
										<div class="form-js form-js check-deligoo-availability-form-js">
											<div class="form__input-wrapper">
												<label for="zipCode" class="form__input-info input-info-js"><span class="required">*</span>{{ translations.ZipCode }}</label>
												<input class="form__input-value input-value-js" id="zipCode" aria-label="{{ translations.ZipCode }}" type="text" name="zipCode" value="{{ cart.Customer.DeliveryAddress.ZipCode }}" required maxlength="20" {% if cart.Customer.DeliveryAddress.ZipCode != '' -%} readonly {% endif -%}>
												<input type="hidden" name="countryCode" value="" data-zip-regex="^\d{2}-\d{3}$">
												<input type="hidden" name="__action" value="Order/FastDeliveryCheck">
											</div>
											<button class="cart__action-btn check-deligoo-availability-js {% if deligooSelected and cart.Customer.DeliveryAddress.ZipCode != '' -%} check-deligoo-when-enter-cart-js {% endif -%} {% if cart.Customer.DeliveryAddress.ZipCode != '' -%} hidden-js {% endif -%}">
												{{ translations.Check }}
											</button>
											<svg class="deligoo-success-icon-js hidden-js">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
											</svg>
											<svg class="deligoo-error-icon-js hidden-js">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
											</svg>
											<div class="validation-info-js validation-required-js hidden-js small-input-error small-input-error">
												{{ translations.FillZipCode }}
											</div>
											<div class="validation-info-js validation-zip-code-js hidden-js small-input-error">
												{{ translations.FillProperZipCode }} XX-XXX
											</div>
										</div>
										<div class="deligoo-success-js hidden-js">{{ translations.DeligooSuccessInCart }}</div>
										<div class="deligoo-error-js hidden-js">{{ translations.DeligooErrorInCart }}</div>
									</div>
								</div>
							</div>
						</div>
					{% endif -%}

					<button class="primary-action-button cart__save-btn cart-edit-view-js cart-validate-delivery-js cart-update-summary-js" data-view="paymentMethods">
						{{translations.ButtonSave}}
					</button>
				{% else -%}
					<div class="cart-address-presentation">
						<div class="cart-address-presentation__text">
							<div>{{ translations.MethodOfDelivery }}:</div>
							<div class="cart-selected-delivery-name-js" data-name="{{ cart.SelectedDelivery.Name }}">
								{{ cart.SelectedDelivery.Name }}
							</div>
						</div>

						{% if cart.SelectedDelivery.CollectionPoint -%}
							<div class="cart-address-presentation__text column">
								<div>{{ translations.ChoosenCollectionPoint }}:</div>
								<div>
									{% assign cp = cart.SelectedDelivery.CollectionPoint -%}
									{% assign name = cp.Address | Split:',' | Last | Split:'(' | First -%}
									{% if name == '' or name == ' ' or name == '  ' -%}
										{% assign name = cp.Address | Split:'(' | Last | Remove:')' -%}
										{% capture name -%}{{name}}{% endcapture -%}
									{% endif -%}
									<strong>{{name}}</strong>
									<br >
									{{cp.Street}} {{cp.StreetNo}}{% if cp.UnitNo != null and cp.UnitNo != '' -%}/{{cp.UnitNo}}{% endif -%}
									<br >
									{{cp.ZipCode}} {{cp.City}}
									<br >
									{{cp.Country}}
								</div>
							</div>
						{% endif -%}

						{% if cart.SelectedDelivery.DateText != "" or settings.scheduledDeliveryDateEditable == 'yes' and cart.SelectedDelivery.Time >= 0 -%}
							<div class="cart-address-presentation__text">
								<div>{{ translations.ExpectedDeliveryTime }}:</div>
								<div>
									{% if settings.scheduledDeliveryDateEditable == 'yes' and  cart.SelectedDelivery.SelectedDate -%}
										{% if settings.deliveryDateType == 'date' -%}
											{% if cart.SelectedDelivery.SelectedDate -%}
												{{ cart.SelectedDelivery.SelectedDate | Date:'yyyy-MM-dd' }}
											{% else -%}
												{{ config.Now | Plus: days | Date:'yyyy-MM-dd' }}
											{% endif -%}
										{% else -%}
											{% if cart.SelectedDelivery.SelectedDate -%}
												{{ cart.SelectedDelivery.SelectedDate | Date:'yyyy-MM-ddTHH:mm' }}
											{% else -%}
												{{ config.Now | Plus: days | Date:'yyyy-MM-ddTHH:mm' }}
											{% endif -%}
										{% endif -%}
									{% elseif cart.SelectedDelivery.DateText != "" -%}
										{{ cart.SelectedDelivery.DateText }}
									{% endif -%}
								</div>
							</div>
						{% endif -%}

						{% if cart.NotDeterminedDeliveryCost == false and cart.SelectedDelivery.NotDeterminedDeliveryCost == false -%}
							<div class="cart-address-presentation__text">
								<div>{{ translations.DelivCost }}:</div>
								<div>
									{{ cart.SelectedDelivery.TotalValue | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
								</div>
							</div>
						{% endif -%}

					</div>
				{% endif -%}
		{% endif -%}
    </div>
</div>

{% unless deliveryMethodsSize == 0 -%}
	<div class="cart-data-section">
		<div class="cart-data-section__header">
			<div class="cart-data-section__header-title">
				<div>
					{{ translations.MethodOfPayment }}
				</div>
				{% assign creditLimit = customer.CreditLimit -%}
				{% if creditLimit -%}
					{% if creditLimit.OverdueActive and creditLimit.OverdueLeft < 0 -%}
						{% assign creditLimitLabel = translations.CreditLimitOverdueLeft -%}
						{% assign creditLimitValue = creditLimit.OverdueLeft -%}
					{% elseif creditLimit.Active -%}
						{% assign creditLimitLabel = translations.CreditLimitLeft -%}
						{% assign creditLimitValue = creditLimit.Left -%}
					{% else -%}
						{% assign creditLimitLabel = translations.CreditLimitOverdueLeft -%}
						{% assign creditLimitValue = creditLimit.OverdueLeft -%}
					{% endif -%}
					{% if creditLimit.OverdueActive or creditLimit.Active -%}
						<div class="cart-data-section__header-small">
							<span>{{ creditLimitLabel }}: </span>
							<span class="credit-left-js">{{ creditLimitValue }} {{ customer.CurrencyExt }}</span>
						</div>
					{% endif -%}
				{% endif -%}
			</div>

			{% if noAddress == false and showPaymentMethods == false -%}
				<div>
					<button class="cart__action-btn cart-data-section__header-btn cart-edit-view-js" data-view="paymentMethods">
						{{ translations.Edit }}
					</button>
				</div>
			{% endif -%}
		</div>
		<div class="cart-data-section__content">
			{% if showPaymentMethods and showDeliveryMethodsForm == false and showDeliveryAddressForm == false and showInvoiceAddressForm == false -%}
				{% assign disableOrderButton = true -%}
				{% for deliveryMethod in cart.DeliveryMethods -%}
					{% if deliveryMethod.Name == cart.SelectedDelivery.Name -%}
						{% assign indexTemp = forloop.index0 -%}
						{% for payment in deliveryMethod.Payments -%}
							{% if payment.Id == cart.SelectedDeliveryPaymentId -%}
								{% assign index = indexTemp -%}
							{% endif -%}
						{% endfor -%}
					{% endif -%}
				{% endfor -%}
				{% if settings.scheduledDeliveryDateEditable == 'yes' and cart.SelectedDelivery.SelectedDate -%}
					{% if settings.deliveryDateType == 'date' %}
						{% assign dateValue = cart.SelectedDelivery.SelectedDate | Date:'yyyy-MM-dd' -%}
					{% else -%}
						{% assign dateValue = cart.SelectedDelivery.SelectedDate | Date:'yyyy-MM-ddTHH:mm' -%}
					{% endif -%}
				{% endif -%}
				{% for payment in cart.DeliveryMethods[index].Payments -%}
					<label class="cart-delivery-item">
						<div class="cart-delivery-item__radio">
							<input class="cart__radio change-delivery-js payment-js" 
								type="radio" 
								name="id" 
								value="{{ payment.Id }}" 
								{% if payment.Id == cart.SelectedDeliveryPaymentId -%} checked {% endif -%} 
								data-delivery-index="{{index}}"
								data-name="{{ payment.Name }}"
								data-template="partials/cart/delivery-partials/delivery-section.html" 
								data-container=".delivery-section-container-js"
								data-include="paymentMethods"
								data-selected-date="{{dateValue}}"
							>
							<div aria-label="{{ payment.Name }}" tabindex="0" role="radio" {% if payment.Id == cart.SelectedDeliveryPaymentId -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} class="cart__radio-box"></div>
						</div>
						<div class="cart-delivery-item__wrapper">
							<div class="cart-delivery-item__name">
								{% if payment.ImageUrl != null -%}
									<img src="css/img/alo.gif" data-src="{{payment.ImageUrl}}" alt="{{payment.Name}}" title="{{payment.Name}}" >
								{% endif -%}
								{{ payment.Name }}
							</div>

							{% if cart.SelectedDelivery.Name == cart.DeliveryMethods[index].Name -%}
								{% if payment.Id == cart.SelectedDelivery.Payment.Id and payment.Channels[0] -%}
										{% for channel in payment.Channels -%}
											{% if channel.Key == cart.SelectedDelivery.Payment.Channel.Key  -%}
												{% assign paymentChannelChosen = true -%}
											{% endif -%}
											<div class="cart-delivery-item__payment-channel choosen-payment-channel-js {% if channel.Key != cart.SelectedDelivery.Payment.Channel.Key -%} hidden-js {% endif -%}" data-key="{{channel.Key}}">
												<img src="css/img/alo.gif" data-src="{{channel.ImageUrl}}" alt="{{ channel.Name }}" title="{{ channel.Name }}">
												<div role="button" tabindex="0" class="cart__action-btn open-comfortable-payment-channels-popup-background-js">{{ translations.ChangeChannelPayment }}</div>
											</div>
										{% endfor -%}
										{% if cart.SelectedDeliveryPaymentChannelKey == null -%} 
											{% assign SelectedDeliveryPaymentChannelKey = false -%}
										{% else -%} 
											{% assign SelectedDeliveryPaymentChannelKey = true -%}
										{% endif -%} 
										<div role="button" tabindex="0" class="cart__action-btn open-comfortable-payment-channels-popup-background-js cart-choosePaymentChannel {% if SelectedDeliveryPaymentChannelKey == true -%} hidden-js {% endif-%}">{{ translations.ChoosePaymentChannel }}</div>
								{% endif -%}
							{% endif -%}

							<div class="cart-delivery-item__price">
								{% if cart.NotDeterminedDeliveryCost == false and cart.SelectedDelivery.NotDeterminedDeliveryCost == false -%}
									{{ payment.TotalValue | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
								{% else -%}
									<div class="cart-delivery-item__price-text">
										{{ translations.IndividualPrice }}
										<div class="cart__tooltip cart-tooltip-js">
											<svg class="cart__tooltip-icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
											</svg>
											<div class="cart__tooltip-info cart-tooltip-info-js hidden-js">
												{{ translations.NotDeterminedDeliveryCostInfo }}
											</div>
										</div>
									</div>
								{% endif -%}
							</div>

							{% if cart.SelectedDelivery.Name == cart.DeliveryMethods[index].Name -%}
								{% if payment.Id == cart.SelectedDelivery.Payment.Id and payment.FreePaymentFrom > cart.ProductsValue and payment.TotalValue > 0 -%}
									<div class="cart-delivery-item__price-free">
										{{ translations.FreePaymentFrom }}: {{ payment.FreePaymentFrom | Round: config.DecimalPlacesPrice | ToPrice }} {{ cart.CurrencyExt }} {% if customer.SubtotalPrices -%} {{ translations.Netto | Downcase }} {% endif -%}
									</div>
								{% endif -%}
							{% endif -%}
							{% if payment.Id == cart.SelectedDeliveryPaymentId and cart.SelectedDelivery.Payment.DueDateText != "" -%}
								<div class="cart-delivery-item__date info">
									{{ translations.ScheduledPaymentDate }}
									<br >
									{{ cart.SelectedDelivery.Payment.DueDateText }}
								</div>
							{% endif -%}
						</div>
					</label>

					{% if cart.SelectedDelivery.Name == cart.DeliveryMethods[index].Name -%}
						{% if payment.Id == cart.SelectedDelivery.Payment.Id and payment.Channels[0] -%}
								<div class="cart__popup comfortable-payment-channels-popup-background-js {% if paymentChannelChosen -%} hidden-js {% endif -%}">
									<div class="cart__popup-box channels">
										<div class="cart__popup-header">
											<div class="cart__popup-title--with-button">
												<span>{{ translations.ChoosePaymentChannel }}</span>
												<button class="close-button closing-modal-js close-comfortable-payment-channels-popup-background-js" aria-label="{{ translations.Close }}">
													<svg aria-hidden="true">
														<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
													</svg>
												</button>
											</div>
										</div>
										<div class="cart__popup-content cart-payment-channel comfortable-payment-channels-popup-js payment-channels-js">
											{% for channel in payment.Channels -%}
												<label role="button" tabindex="0" class="cart-payment-channel__item payment-channel-js {% if channel.Key == cart.SelectedDeliveryPaymentChannelKey -%} active-js {% endif -%} close-comfortable-payment-channels-popup-background-js closing-modal-js">
													<div class="cart-payment-channel__item-img">
														<input aria-label="channel" type="radio" name="channel" value="{{channel.Key}}" {% if channel.Key == cart.SelectedDeliveryPaymentChannelKey -%} checked {% endif -%}>
														<img src="css/img/alo.gif" data-src="{{channel.ImageUrl}}" alt="{{ channel.Name }}" title="{{ channel.Name }}">
													</div>
													<div class="cart-payment-channel__item-name">{{channel.Name}}</div>
												</label>
											{% endfor -%}
										</div>
									</div>
								</div>
						{% endif -%}
					{% endif -%}
				{% endfor -%}

				<button class="primary-action-button cart__save-btn cart-edit-view-js cart-update-summary-js">
					{{translations.ButtonSave}}
				</button>
			{% else -%}
				<div class="cart-address-presentation">
					<div class="cart-address-presentation__text">
						<div>{{ translations.MethodOfPayment }}:</div>
						<div>
							{{ cart.SelectedDelivery.Payment.Name }}
						</div>
					</div>
					
					{% if cart.SelectedDelivery.Payment.Channel -%}
						<div class="cart-address-presentation__text">
							<div>{{ translations.ChannelOfPayment }}:</div>
							<div>
								{{ cart.SelectedDelivery.Payment.Channel.Name }}
							</div>
						</div>
					{% endif -%}

					{% if cart.NotDeterminedDeliveryCost == false and cart.SelectedDelivery.NotDeterminedDeliveryCost == false -%}
						<div class="cart-address-presentation__text">
							<div>{{ translations.PaymentCost }}:</div>
							<div>
								{{ cart.SelectedDelivery.Payment.TotalValue | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
							</div>
						</div>
					{% endif -%}
					
				</div>
				{% include 'partials/product/installment-calculator.html' with cart -%}
			{% endif -%}			
		</div>
	</div>
{% endunless -%}

<div class="form-js no-message-js delivery-form-js">
	<input type="hidden" name="__action" value="Order/DeliveryChange" >
	<input type="hidden" name="id" data-type="{{ cart.SelectedDelivery.CollectionPointTypeId }}" value="{{cart.SelectedDeliveryPaymentId}}" >
</div>

<div class="cart-data-section last">
    <div class="cart-data-section__header">
        <div class="cart-data-section__header-title">
            <div>
				{{translations.OrderNotes}}
            </div>
        </div>
    </div>
    {% if showNotesForm -%}
    	<div class="cart-data-section__content note-js">
			{% include 'partials/cart/note-partials/note-form.html' with 'true' -%}
    	</div>
	{% endif -%}
</div>

{% assign lockOrderButton = true -%}

{% if showDeliveryAddressForm == false and showDeliveryAddressChoose == false and showInvoiceAddressForm == false and showDeliveryMethodsForm == false and showPaymentMethods == false -%}
	{% assign lockOrderButton = false -%}
{% endif -%}

{% if deliveryMethodsSize == 0 -%}
	{% assign lockOrderButton = true -%}
{% endif -%}

{% unless include == 'init' -%}
	<script>
		if ($('.add-order-js').length > 0) {
			{% if lockOrderButton -%}
				$('.add-order-js').attr('disabled', true);
			{% else -%}
				$('.add-order-js').attr('disabled', false);
			{% endif -%}
		}
	</script>
{% endunless -%}
<script>
	if($('.map-container-in-order-js').hasClass('collection-point-selected-js') || $('.collection-point-container-in-cart-js').hasClass('collection-point-selected-js')){
		window.choosenCollectionPointId = true;
	}
</script>
`